import { ArrowClockwise } from '@phosphor-icons/react';
import { Button } from '@/components/ui-kit/button';
import { formatMembersLabel, formatRelativeAsOf } from '../utils/segments-format';

export type SegmentMemberCellProps = {
  matchCount: number | null;
  matchCountAt: string | null;
  isRefreshing?: boolean;
  onRefresh?: () => void;
};

export const SegmentMemberCell = ({
  matchCount,
  matchCountAt,
  isRefreshing = false,
  onRefresh,
}: SegmentMemberCellProps) => {
  if (matchCount === null) {
    return <span className="text-[13px] leading-[18px] text-neutral-500">Not yet calculated</span>;
  }

  return (
    <div className="flex items-center gap-2">
      <div className="flex flex-col leading-tight">
        <span className="font-medium text-neutral-900">{formatMembersLabel(matchCount)}</span>
        <span className="text-[13px] leading-[18px] text-neutral-500">
          Estimate{matchCountAt ? ` · as of ${formatRelativeAsOf(matchCountAt)}` : ''}
          {isRefreshing ? ' · refreshing…' : ''}
        </span>
      </div>
      {onRefresh ? (
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="size-7 shrink-0 text-neutral-500"
          aria-label={isRefreshing ? 'Refreshing count' : 'Refresh count'}
          disabled={isRefreshing}
          onClick={(event) => {
            event.stopPropagation();
            onRefresh();
          }}
        >
          <ArrowClockwise className={isRefreshing ? 'size-4 animate-spin' : 'size-4'} aria-hidden />
        </Button>
      ) : null}
    </div>
  );
};
